import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { TABLE_BORDER_COLOR } from 'HubStyleTokens/theme';
import GridItem from '../GridItem';
import { mediaQueries } from '../../utils/mediaQueries';
const sharedColumnStyles = css(["border-color:", ";border-style:solid;"], TABLE_BORDER_COLOR);
const RightColumn = styled(GridItem).withConfig({
  displayName: "RightColumnComp__RightColumn",
  componentId: "x197g0-0"
})(["", " overflow-x:auto;&&{padding:28px 16px 0 16px;}", "{&&{padding:16px 0 0 0;}}"], sharedColumnStyles, mediaQueries.belowLaptop);

const RightColumnComp = ({
  children,
  columnSpan
}) => {
  return /*#__PURE__*/_jsx(RightColumn, {
    columns: columnSpan,
    className: "right-column",
    children: children
  });
};

export default RightColumnComp;